import { createAction } from '@ngrx/store';
import { Bridge485TemplateInternalModel } from '@spog-ui/shared/models/bridge-485-templates';

export const loadBridge485TemplatesAction = createAction(
  '[Bridge 485 Templates State] Load Templates',
  (templates: Bridge485TemplateInternalModel[]) => ({ templates }),
);
